// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// the first path import CSV interface has three form which need to talk to eachother.
// these form's names are stored in a constants file and these constants are used in
// place of hard coding the string value in each file.

export const PATH_IMPORT_CSV = 'path-import-csv'
export const PATH_IMPORT_CSV_MAPPING_CREATE = 'path-import-csv-mapping-create'
export const PATH_IMPORT_CSV_MAPPING_FILTER = 'path-import-csv-mapping-filter'
export const PATH_IMPORT_CSV_RESULTS_TABLE = 'path-import-csv-results-table'
